// import $external from '@/gavnoCode/external';
import axios from 'axios';
// import $myApi from '@/gavnoCode/ApiHandler';
const state = {
  pskTable: [],
  selectSumm:0,
  selectProduct:'',
  selectWeek: 0,
  WeeklyPayment:0,
  summLimit:0,//ограничение по максимальной сумме займа.
  topUp:0,
  PreTopup:0,
};

const actions = {
  addPskTable: ({commit, getters}, newPsk) => {
    //если таблички одинаковые, то не творим новый гавнокодик в промисах
    if (JSON.stringify(state.pskTable) !== JSON.stringify(newPsk)) {
      commit('updatePsk', newPsk);
      let baseProduct = getters.getProduct.filter((item)=>item.ProductType == 'S');
      if (baseProduct.length > 0) {
        commit('setSelectProduct', baseProduct[0]['ProductType'])
      }
      let defWeek = getters.getAvailablePeriod;
      if (defWeek.length > 0) {
        commit('setSelectWeek', defWeek[0]);
      }
      let defSumm = getters.getAvailableSum;
      if (defSumm.length > 0) {
        commit('setSelectSumm', defSumm[defSumm.length - 1]);
      }
    }
  },
  loadDefaultPsk:({dispatch})=>{
    if (state.pskTable.length == 0) {
      // $myApi.singleRequest({
      //   action:'loadDefaultPsk'
      // }).then(res=> dispatch('addPskTable', res))
      // .catch(res=>console.log(res));

        axios({
          method: 'POST',
          url: process.env.VUE_APP_URL_API_MS + '/loadDefaultPsk.php',
        }).then((res)=>{
          console.log(dispatch('addPskTable', res.data.Data))
        }).catch((res)=>{
          alert('loadDefaultPsk ' + res);
        })


    }
  },
  loadPsk:({dispatch})=>{
    //проверяем изменения в пск, если придет пустой массив изменений нет
    // иначе сохроняем в мускл новые пск в клиент показываем принятый массив
    dispatch('loadDefaultPsk');
    // $external.universalRequest({
    //   externalType: 'zita',
    //   action: 'getPsk',
    // }).then(res=>{
    //   if(typeof res == "object" && res.length > 0) {
    //     dispatch('addPskTable', res);
    //     $myApi.singleRequest({
    //       action:'savePsk',
    //       data:res,
    //     }).then(res=>console.log(res))
    //     .catch(res=>console.log(res));
    //   } else {
    //     dispatch('loadDefaultPsk');
    //   }
    // })
    // .catch(res=>{
    //   if ( res.errorCode > 0 || res.errorCode !== undefined ) {
    //     alert('Ошибка' + ' ' + res.errorCode + ': ' + res.errorMsg)
    //   }
    //   dispatch('loadDefaultPsk');
    // });


    //процедура с ставками 25 на 25

    // $external.universalRequest({
    //   externalType: 'zita',
    //   action:'DealType_display',
    //   MaxID:0
    // }).then((res)=>{
    //   dispatch('addPskTable', res);
    // }).catch((res)=>{
    //   alert(res)
    // })
  },
  loadTrigerUpdateSummSelector:({commit}, demandObj) =>{
    if (demandObj.WeeklyPayment != undefined && demandObj.WeeklyPayment > 0) {
     commit('setWeeklyPayment',demandObj.WeeklyPayment);
    }
    if (demandObj.DolgTopup  != undefined && demandObj.DolgTopup  > 0) {
      commit('settopUp',demandObj.DolgTopup);
    }
    if (demandObj.PreTopup  != undefined ) {
      commit('setPreTopup',demandObj.PreTopup);
    }
  }
};

const mutations = {
  updatePsk: (state, newPsk) => {
    state.pskTable = newPsk;
  },
  setSelectProduct:(state, newValue)=>{
    state.selectProduct = newValue;
  },
  setSelectWeek:(state, newValue)=>{
    state.selectWeek = newValue;
  },
  setWeeklyPayment:(state, newValue)=> {
    state.WeeklyPayment = newValue;
  },
  setSelectSumm:(state, newValue)=>{
    state.selectSumm = newValue;
  },
  setSummLimit:(state, newValue)=> {
    state.summLimit = parseInt(newValue,10);
  },
  settopUp:(state, newValue)=> {
    state.topUp = newValue;
  },
  setPreTopup:(state, newValue)=> {
    state.PreTopup = parseInt(newValue,10);
  }
};

const getters = {
  getAvailableSum: (state) => {
    let result = [];

    try {
      let out = state.pskTable.filter(item => {
        //получаем доступнные варианты сумм для выбранного продукта
        return item.ProductType === state.selectProduct && item.Period === state.selectWeek
      }).sort(function (a, b) {
        return a.Amount - b.Amount;
      });
      out.forEach(value => {
        let findResult = result.find(valueF => {
          return valueF == value.Amount;
        });
        if (findResult === undefined) {
          result.push(value.Amount);
        }
      })
    } catch (e) {
      console.log(e);
    }
    return result;
  },
  getSummWithTopUp: (state) => {
    if (isNaN(parseInt(state.selectSumm, 10)) )  {
      return 'Сначала выберите сумму';
    }

    return parseInt(state.selectSumm, 10)  - state.topUp},
  getLimitAvailableSum: (state) =>{
    let result = [];
    const WeeklyPayment = parseInt(state.WeeklyPayment, 10);
    const summLimit = parseInt(state.summLimit, 10);
    
    let calcMinSumm = (WeeklyPayment > 0 || summLimit > 0) ?
      (WeeklyPayment >= summLimit && summLimit > 0) ?
        summLimit : WeeklyPayment
      : 0;

    try {

      let out = [];
      if (state.selectProduct.length > 0) {
        out = state.pskTable.filter(item => {
          //получаем доступнные варианты сумм для выбранного продукта
          return (item.ProductType === state.selectProduct && parseInt(item.FixedPay, 10) <= calcMinSumm && item.Period === state.selectWeek)
        }).sort(function (a, b) {
          return a.Amount - b.Amount;
        });
      }
      console.log(out);
      out.forEach(value => {
        let findResult = result.find(valueF => {
          return valueF == value.Amount;
        });
        if (findResult === undefined) {
          result.push(value.Amount);
        }
      })
    }catch (e) {
      console.log(e);
    }
    return result;
  },
  getProduct: (state) => {
    let result = [];
    try {
      state.pskTable.forEach(value => {
        let findResult = result.find(valueF => {
          return valueF.ProductType == value.ProductType;
        });
        if (findResult === undefined) {
          result.push({ProductType: value.ProductType, DlProductTypeName: value.DlProductTypeName});
        }
      });
    } catch (e) {
      console.log(e);
    }
    return result;
  },
  getAvailablePeriod: (state) => {
    let result = [];
    try {
      // выводим простыню по данному продукту product_id
      let currentPsk = state.pskTable.filter(value => value.ProductType === state.selectProduct);
      // находим уникальные значение по периоду в полученной простыне
      currentPsk.forEach(value => {
        let findResult = result.find(valueF => {
          return valueF == value.Period
        });
        if (findResult === undefined) {
          result.push(value.Period);
        }
      });
    } catch (e) {
      console.log(e);
    }
    try {
      if (result.length > 0) {
        state.selectWeek = result[result.length - 1];
      }

    } catch (e) {
      console.log(e);
    }
    return result;

  },
  getSelectedPskInfo: (state) => {
    //ишем соовтевтсиве в табличке по сумме и типу продукта
    let filteredRow = state.pskTable.filter(item => {
      return item.Amount == state.selectSumm
        && item.ProductType == state.selectProduct
        && item.Period == state.selectWeek
    });
    if (filteredRow.length == 1) {
      //возращаем значение для данной суммы с расширением переплата продукта
      filteredRow[0]['OutDeltaPayments'] = Math.ceil((filteredRow[0]['OutPayments'] - state.selectSumm)*100)/100;
      //хардкор костыль на красивое окончание
      switch (filteredRow[0]['PeriodType_id']) {
        case '1':
          filteredRow[0]['calcWeekTitle'] = '(Недели)';
          filteredRow[0]['periodPayTitle'] = 'Еженедельный';
          break;
        case '2':
          filteredRow[0]['calcWeekTitle'] = '(Месяцы)';
          filteredRow[0]['periodPayTitle'] = 'Ежемесячный';
          break;
        default:
          filteredRow[0]['calcWeekTitle'] = '';
          filteredRow[0]['periodPayTitle'] = '';
          break;
      }
      return filteredRow[0];
    } else {
      return {
        Amount: 0,
        DlProductTypeName: '-',
        FixedPay: 0,
        OutPayments: 0,
        PercentageRate: 0,
        Period: 0,
        ProductType: 0,
        DlProductTypeID: 0,
        PeriodType: 0,
        PeriodType_id: 0,
        OutDeltaPayments: 0
      };
    }
  },
  getSelectedValue:(state)=>{
    return {
      CALC_WEEK:state.selectWeek,
      PRODUCT_ID:state.selectProduct,
      CALC_SUMM:state.selectSumm,
    }
  }
};

export default {
  state,
  mutations,
  getters,
  actions
}
